import Vue from 'vue'
import VueRouter from 'vue-router'
import RoutePaths from '../constants/routePaths'
import RouteNames from '../constants/routeNames'
import Confirmation from '../views/Confirmation.vue'
import MissedDelivery from '../views/MissedDelivery.vue'
import PageNotFound from '../views/Errors/PageNotFound.vue'
import PageHeaderTitles from '../constants/pageHeaderTitles'
import PreDeliveryRedirection from '../views/PreDeliveryRedirection.vue'
import PostageRateCalculator from '../views/PostageRateCalculator.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: RoutePaths.MissedDelivery,
        name: RouteNames.MissedDelivery,
        component: MissedDelivery,
        meta: {
            pageHeaderTitle: PageHeaderTitles.MissedDelivery,
            pageHeaderRedirectionPath: null
        }
    },
    {
        path: RoutePaths.Confirmation,
        name: RouteNames.Confirmation,
        component: Confirmation,
        meta: {
            pageHeaderTitle: PageHeaderTitles.MissedDelivery,
            pageHeaderRedirectionPath: RoutePaths.MissedDelivery
        }
    },
    {
        path: RoutePaths.PreDeliveryRedirection,
        name: RouteNames.PreDeliveryRedirection,
        component: PreDeliveryRedirection,
        meta: {
            pageHeaderTitle: PageHeaderTitles.PreDeliveryRedirection,
            pageHeaderRedirectionPath: null
        }
    },
    {
        path: RoutePaths.PostageRateCalculator,
        name: RouteNames.PostageRateCalculator,
        component: PostageRateCalculator,
        meta: {
            pageHeaderTitle: PageHeaderTitles.PostageRateCalculator,
            pageHeaderRedirectionPath: null
        }
    },
    {
        path: '*',
        name: RouteNames.PageNotFound,
        component: PageNotFound,
        meta: {
            pageHeaderTitle: '',
            pageHeaderRedirectionPath: null
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
